import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pnidApi } from '../api';
import { queryKeys } from '../queries/keys';
import type { PnidSetupUpdate } from '../types';

export function useSetPnidSetup(docId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (setup: PnidSetupUpdate) => pnidApi.setPnidSetup(docId, setup),
    // The cache holds drawing GET answers alone, so the save's answer is read back from the GET.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.pnidState(docId) }),
  });
}
